// extracted by mini-css-extract-plugin
export default {"textarea":"MarkdownEditor-module__textarea___KzziA","editor-label-wrapper":"MarkdownEditor-module__editor-label-wrapper___XKtQ6"};